import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import PlainFieldset from '@/components/atoms/Fieldset/templates/PlainFieldset';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import { useBillingState, getPercentage } from '@/modules/billing/hooks/useBillingState';
import { selectAccountSlug } from '@/redux/session/selectors';

import { FIELDSET_CARD_PADDING } from '../../../constants';

const BillingFieldset = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const billingState = useBillingState();

  const { days_left, plan_id, has_expired } = billingState ?? {};
  const slug = useSelector(selectAccountSlug);

  const handleClick = () => {
    navigate(`/${slug}/account/billing`, { state: { shouldTriggerAction: Date.now() } });
  };

  if (plan_id !== 'trial') {
    return null;
  }

  const title = has_expired
    ? t('home.billing.upgrade')
    : t('home.billing.currently_trial', { 0: plan_id });
  const label = has_expired
    ? t('home.billing.free_expired')
    : t('home.billing.upgrade_within', { 0: days_left });

  return (
    <PlainFieldset fullWidth className={FIELDSET_CARD_PADDING}>
      <div className="flex w-full justify-between">
        <div className="flex w-[316px] flex-col gap-1 pt-2 pb-4">
          <span className="text-base leading-6 font-semibold text-foreground">{title}</span>
          <Progress
            value={getPercentage(days_left)}
            className="h-1 rounded bg-stroke"
            indicatorClassName={cn('rounded', has_expired && 'bg-destructive')}
          />
          <span className={cn('text-sm text-foreground', has_expired && 'text-destructive')}>
            {label}
          </span>
        </div>

        <Button onClick={handleClick}> ✨ {t('billing.upgrade')}</Button>
      </div>
    </PlainFieldset>
  );
};

export default BillingFieldset;
